import { Component, Input } from "@angular/core";
import { WorkOrder } from "../../model";

@Component({
    selector: 'work-order-card',
    template: require('./work-order-card.component.html'),
    styles: [require('./work-order-card.component.css')]
})
export class WorkOrderCardComponent {

    @Input() workOrder: WorkOrder;

}